import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ChevronDownIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-chevron-down">
    <path
      d="M12 20 L25 32 L38 20"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinejoin="miter"
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default ChevronDownIcon;
